<template>
  <div class="@container">
    <p
      class="text-gray-500 text-sm @md:text-base"
     
    >
      {{ summary }}
      <button
       
        class="link"
        @click="isDetailsVisible = true"
      >
        {{ t('booking.cancellationPolicyDetails.link') }}
      </button>
    </p>

    <TModalInfo
      v-model:visible="isDetailsVisible"
      :title="t('booking.cancellationPolicyDetails.title')"
      :label-primary="t('booking.cancellationPolicyDetails.moreDetails')"
      size="2xl"
      enable-scroll
      @action:primary="openHelpCenter"
    >
      <div
        class="space-y-6"
        aria-live="polite"
      >
        <p>
          {{ summary }}
        </p>

        <div
          v-for="tier in TIER_KEYS"
          :key="tier"
          :class="{ 'bg-primary-50 rounded px-4 py-2': tier === applicableTier }"
          :aria-current="tier === applicableTier ? true : undefined"
         
        >
          <THeading
            :level="6"
            tag="h2"
          >
            {{ t(`booking.cancellationPolicyDetails.tiers.${tier}.label`) }}
          </THeading>
          <p>{{ t(`booking.cancellationPolicyDetails.tiers.${tier}.description`) }}</p>
        </div>

        <div
          v-for="fee in ['alwaysRefundable', 'notRefundable']"
          :key="fee"
        >
          <THeading
            :level="6"
            tag="h2"
          >
            {{ t(`booking.cancellationPolicyDetails.${fee}.label`) }}
          </THeading>
          <p>{{ t(`booking.cancellationPolicyDetails.${fee}.description`) }}</p>
        </div>
      </div>
    </TModalInfo>
  </div>
</template>

<script setup lang="ts">
import { CANCELLATION_POLICY_OPTIONS } from '~/constants/booking'

const props = defineProps<{
  startDate?: string
}>()

const TIER_KEYS = [
  CANCELLATION_POLICY_OPTIONS.MoreThan30Days,
  CANCELLATION_POLICY_OPTIONS.Between8To30Days,
  CANCELLATION_POLICY_OPTIONS.LessThan8Days,
] as const

const { t } = useI18n()
const { rvComputedTimezone } = useRvDetails()

const isDetailsVisible = ref(false)

const hasGracePeriod = computed(() => {
  // With no dates selected we advertise the grace period, because it applies to
  // every trip a guest can still book at least two days out.
  return !props.startDate || isGracePeriodEligible(props.startDate, rvComputedTimezone.value)
})

const summary = computed(() => {
  return hasGracePeriod.value ? t('booking.cancellationPolicyDetails.gracePeriod') : t('booking.cancellationPolicyDetails.standardOnly')
})

const applicableTier = computed(() => getCancellationPolicyByStartDate(props.startDate, rvComputedTimezone.value))

async function openHelpCenter() {
  await navigateTo(t('booking.cancellationPolicyDetails.helpCenterUrl'), {
    external: true,
    open: { target: '_blank' },
  })
}
</script>

<i18n src="~~/i18n/locales/common/booking/cancellation-policy.json" lang="json" />
